import { PropsWithChildren } from "react"

const ModalHeader = ({children}: PropsWithChildren<{}>) => {
    return (
        <div className={`sb3-border-b  !sb3-px-6 !sb3-py-2`}>
            {children}
        </div>
    )
}
export default ModalHeader